import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadRepository } from '../../../domain/repositories/lead/lead.repository';
import {
  UpdateLeadPauseInput,
  UpdateLeadResult,
} from '../../../domain/interfaces/lead/lead.interface';

@Injectable({
  providedIn: 'root',
})
export class SaveLeadPauseDataUseCase {
  private readonly leadRepository = inject(LeadRepository);

  execute(input: UpdateLeadPauseInput): Observable<UpdateLeadResult> {
    return this.leadRepository.saveLeadPauseData(input);
  }
}
